export default "__VITE_ASSET__yMDBt33$__"